module.exports = __webpack_public_path__ + "img/telegram.7b63b682.svg";